import React from 'react';
import { ContextValues } from './interface';

const Context = React.createContext(({} as unknown) as ContextValues);

export const Provider = Context.Provider;

export const useContext = () => React.useContext(Context);
